/*** IMPORTS FROM imports-loader ***/
var _ = require("lodash");

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'; // 转义es6的API，如promise
import Vue from 'vue';
import App from 'components/baseFrame/baseFrame';
import router from 'router';
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import 'assets/scss/element-variables.scss';
import 'assets/scss/common.scss';
import 'font-awesome/scss/font-awesome.scss';
import fastclick from 'fastclick';
import { VeeValidate, Veeconfig } from 'assets/js/validate';
import store from 'store';
import * as filters from 'assets/js/filters';
import VueLazyload from 'vue-lazyload';
const img = require('../../components/common/nav/icon_face@2x.png')

Vue.use(VueLazyload, {
  loading: require('assets/image/defaultAvatar.png'),
  error: require('assets/image/defaultAvatar.png')
});
fastclick.attach(document.body); // 解决移动端click事件300毫秒的延迟

Vue.config.productionTip = false;

Vue.use(VeeValidate, Veeconfig);
Vue.use(ElementUI);

// 注册全局过滤器
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

Vue.prototype.tipTestMsg = function (){
  this.$alert(`<div class="tips-test-position">
  <img src="${require('@/components/common/nav/icon_face@2x.png')}" alt="" />
  <span class="position-title">欢迎加入我们</span>
  <span class="position-btn">邀测中~</span>
  </div>
  <div class="tips-test-border"></div>
  <div class="tips-test-main">
    <div class="tips-test-item tips-test-left">
      <span class="item-title">造物云公众号：</span>
      <div class="tips-test-img"><img src="${require('@/components/common/nav/icon_code.png')}" alt="" /></div>
    </div>
    <div class="tips-test-item tips-test-right">
      <span class="item-title">联系方式：</span>
      <div class="tips-test-img">
        <img src="${require('@/components/common/nav/icon_mailbox.png')}" alt="" />
        <span>media@eeidm.com</span>
      </div>
    </div>
  </div>`, '', {
  dangerouslyUseHTMLString: true,
  showConfirmButton:false,
  closeOnClickModal:false,
  });
  // this.$alert(
  //   {
  //     message: `
      
  //   `,
  //     title:'',
  //     dangerouslyUseHTMLString: true,
  //     // confirmButtonText: '确定',
  //     showConfirmButton:false,
  //     closeOnClickModal:false,
  //   }
  // )
  // this.$alert(
  //   this.$createElement('div', [
  //     this.$createElement('img', {
  //       attrs: {
  //         src: img,
  //         style: 'width: 32px; height: 32px;vertical-align: middle;margin-right:16px'
  //       }
  //     }),
  //     this.$createElement('span', '当前为邀测阶段，近期将正式对外开放，感谢您的关注')
  //   ]),
  //   '正在邀测中~',
  //   {
  //     confirmButtonText: '确定',
  //     dangerouslyUseHTMLString: true
  //   }
  // )
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
  // components: {
  //     // <v-b> 将只在父组件模板中可用 这里把vue根实例挂载到index.html的#app
  //     // 所以此组件只能在index.html id为app里面使用
  //     'v-b': BB
  // }
});

// 也可以使用$mount挂载根实例
// new Vue({
//   router,
//   render: h => h(App)
// }).$mount('#app');




// WEBPACK FOOTER //
// ./src/view/index/index.js